import { render, staticRenderFns } from "./CartLoginDefaultNote.vue?vue&type=template&id=01405072&"
import script from "./CartLoginDefaultNote.vue?vue&type=script&lang=ts&"
export * from "./CartLoginDefaultNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports